import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Language } from '../models/language.model';

@Injectable({
  providedIn: 'root',
})
export class FormFactoryService {
  seoFields = [
    {
      options: {
        label: 'Tagovi',
        containerClass: 'p-mb-0',
        formControlName: 'slug',
      },
    },
    {
      options: {
        label: 'Tagovi',
        containerClass: 'p-mb-0',
        formControlName: 'meta_title',
      },
    },
    {
      options: {
        label: 'Tagovi',
        containerClass: 'p-mb-0',
        formControlName: 'meta_keywords',
      },
    },
    {
      options: {
        label: 'Tagovi',
        containerClass: 'p-mb-0',
        formControlName: 'meta_description',
      },
    },
  ];
  languages: Language[] = [];

  constructor(private fb: FormBuilder, private store: Store<{ config: any }>) {
    store.select('config').subscribe((res) => {
      this.languages = res.languages;
    });
  }

  createMultiLangForm(fields: any) {
    const form: FormGroup = this.fb.group({});

    this.languages.forEach((lang: any) => {
      // Loop all languages and add fields for every lang
      form.addControl(lang.code, this.createForm(fields));
    });

    return form;
  }

  createForm(fields: any, myForm: FormGroup = null) {
    const form: FormGroup = myForm || this.fb.group({});
    let validators: any[];

    const createField = (singleField: any) => {
      validators = [];
      let newControl;
      if (singleField.options) {
        if (singleField.options.formControlType === 'array') {
          // Create from array
          newControl = new FormArray([]);
        } else {
          // Create form control
          newControl = new FormControl({
            value:
              singleField.options?.value !== undefined &&
              singleField.options?.value !== null
                ? singleField.options?.value
                : '',
            disabled: singleField.options?.disabled && true,
          });
        }

        // Add validators to control
        if (singleField.options?.validators?.required) {
          validators.push(Validators.required);
        }
        if (singleField.options?.validators?.email) {
          validators.push(Validators.email);
        }
        if (singleField.options?.validators?.pattern) {
          validators.push(
            Validators.pattern(singleField.options.validators.pattern)
          );
        }
        if (singleField.options?.validators?.maxLength) {
          validators.push(
            Validators.maxLength(singleField.options?.validators?.maxLength)
          );
        }
        if (singleField.options?.validators?.min) {
          validators.push(Validators.min(singleField.options?.validators?.min));
        }

        // Set validators
        newControl.setValidators(validators);
        // Add control to form
        form.addControl(singleField.options.formControlName, newControl);
      }
    };

    fields.forEach((field: any) => {
      if (field.controlType === 'page-seo') {
        this.seoFields.forEach((dummyField) => {
          createField(dummyField);
        });
      }
      if (field.dummyFields) {
        field.dummyFields.forEach((dummyField: any) => {
          createField(dummyField);
        });
      }
      // Check if this is group of dields
      if (field.group) {
        // Loop group of fields
        field.group.forEach((singleField: any) => {
          createField(singleField);
        });
      } else {
        createField(field);
      }
    });

    return form;
  }
}
